import React, { useEffect, useState } from "react";
import "../SubfilterSide/Filter.css";
import Pagination from "./Pagination";
import SubCard from "./SubCard";
import {
  getBySubCategory,
  getBySubCategoryfilter,
} from "../../../network/api/product";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";
import { link } from "../../../config";
import { useTranslation } from "react-i18next";

export default function Pag({
  id,
  page,
  maxPrice,
  minPrice,
  selectedbrands,
  personal,
  update_p,
  sale,
  beforeDays,
  rate,
  subCategoryData
}) {
  const [coinsData, setCoinsData] = useState([]);
  const [rates, setRates] = useState([]);
  const [currentPage, setCurrentPage] = useState(page);
  const [postsPerPage, setPostsPerPage] = useState(12);
  const [totalcount, settotalcount] = useState(1);
  const {t, i18n} = useTranslation();



  useEffect(() => {
    getBySubCategory(id, page).then((result) => {
      setCoinsData(result.data.response);
      setRates(result.data.rates);
      settotalcount(result.data.count);
    });
  }, []);

  useEffect(() => {
    getBySubCategoryfilter({
      id,
      page,
      maxPrice,
      minPrice,
      // selectedbrands,
      sale,
      beforeDays,
      rate,
    }).then((result) => {
      setCoinsData(result.data.response);
      setRates(result.data.rates);
      settotalcount(result.data.count);
    });
  }, [maxPrice, minPrice, id, page, sale, beforeDays]);

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between mt-4"
        style={{ fontSize: "24px" }}
      >
        <h2 className="mb-5 p-0">{i18n.language == "en" ? subCategoryData?.name : subCategoryData?.nameAr}</h2>
        {/* <div className="d-flex align-items-end" style={{ cursor: "pointer" }}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.625 3.75L6.375 9L11.625 14.25"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div> */}
      </div>
      <SubCard
        coinsData={coinsData}
        rates={rates}
        personal={personal}
        update_p={update_p}
        selectedbrands={selectedbrands}
      />
      {/* <Pagination
        id={id}
        page1={page}
        totalPosts={totalcount}
        postsPerPage={postsPerPage}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
      /> */}
    </>
  );
}
